import { Component } from '@angular/core';

@Component({
  selector: 'app-liga',
  templateUrl: './ligayucatan.component.html',
  styleUrls: ['./ligayucatan.component.css']
})
export class LigaYucatanComponent {
}
